(() => {
  if (window.__HARDRIP_UNIFIED_CARD_TAP_V177__) return;
  window.__HARDRIP_UNIFIED_CARD_TAP_V177__ = true;

  const LINK_SELECTOR = [
    '.hardrip-collection-full-link-v175[href]',
    '.collection-card-wrapper a[href*="/collections/"]',
    '.product-card-wrapper a[href*="/products/"]',
    '.card-wrapper a[href*="/products/"]'
  ].join(',');

  const ANIMATION_CLASS = 'hardrip-card-tap-bounce-v177';
  const NAVIGATION_DELAY = 165;

  let navigating = false;

  function isModifiedClick(event) {
    return (
      event.button > 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    );
  }

  function findLink(target) {
    if (!(target instanceof Element)) return null;

    const link = target.closest(LINK_SELECTOR);
    if (!(link instanceof HTMLAnchorElement) || !link.href) return null;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return null;

    if (
      !url.pathname.startsWith('/products/') &&
      !url.pathname.startsWith('/collections/')
    ) {
      return null;
    }

    return link;
  }

  function animationTarget(link) {
    const wrapper = link.closest(
      '.collection-card-wrapper, .product-card-wrapper, .card-wrapper'
    );

    if (!wrapper) return link;

    return (
      wrapper.querySelector(':scope > .card') ||
      wrapper.querySelector('.card') ||
      wrapper
    );
  }

  function playAnimation(target) {
    target.classList.remove(ANIMATION_CLASS);

    // Riavvia sempre l'animazione anche dopo un ritorno indietro del browser.
    void target.offsetWidth;

    target.classList.add(ANIMATION_CLASS);
  }

  document.addEventListener(
    'click',
    (event) => {
      if (navigating || isModifiedClick(event)) return;

      const link = findLink(event.target);
      if (!link) return;

      const target = animationTarget(link);
      const destination = link.href;

      navigating = true;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      playAnimation(target);

      window.setTimeout(() => {
        window.location.assign(destination);
      }, NAVIGATION_DELAY);
    },
    true
  );

  window.addEventListener('pageshow', () => {
    navigating = false;

    document
      .querySelectorAll(`.${ANIMATION_CLASS}`)
      .forEach((element) => element.classList.remove(ANIMATION_CLASS));
  });
})();
